import { Component, OnInit } from '@angular/core';
import validationEngine from 'devextreme/ui/validation_engine';
import moment from 'moment';
import { Job } from 'src/app/core/model/job';
import { RecurringJob } from 'src/app/core/model/recurring-job';
import { User } from 'src/app/core/model/user';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-recurring-job-dialog',
    templateUrl: './recurring-job-dialog.component.html',
    styleUrls: ['./recurring-job-dialog.component.scss'],
    imports: [DevExtremeModule]
})
export class RecurringJobDialogComponent extends BaseDialogComponent<any> implements OnInit {
    recurringJob: RecurringJob;
    frequencyTypeOptions = ['Days', 'Months', 'Years'];
    maxDate: Date;

    constructor() {
        super();
    }

    ngOnInit() {
        this.maxDate = moment(this.recurringJob.startDate).add(5, 'years').toDate();
    }

    save = async () => {
        if (!this.validate()) return;
        this.hide({ success: true });
    };

    cancel = async () => {
        this.hide({ success: false });
    };

    validate() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            return result.isValid;
        }
        return true;
    }
}
